// extracted by mini-css-extract-plugin
export default {"imageContainer":"d0-z","summaryPar":"e0-z","ratingCategories":"f0-z","reviewerInfo":"g0-z","reviewTypes":"h0-z","expanded":"i0-z"};